import { render, staticRenderFns } from "./PerfiLSegurancaFormDialog.vue?vue&type=template&id=371a547c&"
import script from "./PerfiLSegurancaFormDialog.vue?vue&type=script&lang=js&"
export * from "./PerfiLSegurancaFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports